/**
 * getInitials — 2-letter uppercased initials, first-of-first + first-of-last
 * surname, skipping suffixes (Jr/Sr/II/III/IV/V).
 *
 * Examples:
 *   "George Springer"        -> "GS"
 *   "Vladimir Guerrero Jr."  -> "VG"
 *   "Cal Ripken III"          -> "CR"
 *   "Hyun Jin Ryu"            -> "HR"  (first + last token)
 *   "Yohendrick Piñango"      -> "YP"  (diacritics preserved)
 *   "Madonna"                 -> "M"   (single-token names: just the letter)
 *   ""                        -> "?"   (defensive default)
 */
const SUFFIX_RE = /^(?:jr\.?|sr\.?|ii|iii|iv|v)$/i;

export function getInitials(fullName: string | null | undefined): string {
  if (!fullName) return '?';
  const tokens = fullName
    .split(/\s+/)
    .map((t) => t.trim())
    .filter((t) => t.length > 0 && !SUFFIX_RE.test(t));
  if (tokens.length === 0) return '?';
  if (tokens.length === 1) return tokens[0]!.charAt(0).toUpperCase();
  const first = tokens[0]!.charAt(0).toUpperCase();
  const last = tokens[tokens.length - 1]!.charAt(0).toUpperCase();
  return `${first}${last}`;
}
